import { createAction, props } from '@ngrx/store';

export const LoadUserProfile = createAction('[Settings] Load User Profile');
export const UserProfileLoaded = createAction('[Settings] User Profile Loaded', props<{ payload: any }>());
export const UserProfileLoadingFailed = createAction('[Settings] User Profile Loading Failed');


